module.exports = __webpack_public_path__ + "images/checkbox-d13d90c1.svg";